import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enLocale from "./locales/en.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        ...enLocale,
      },
    },
  },
  // TODO: use language detector and implement server side translations if we decide to use more languages
  lng: "en",
  keySeparator: ".",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
